<template>
  <div class="mysearch">
    <div class="myspespace"></div>
    <div class="sp1"></div>
    <van-search v-model="value" @search="onSearch" placeholder="输入快递单号查询包裹信息" />
    <van-tabs class="mysearchtabs" v-model="active">
      <van-tab title="全部">
        <Searchlist1 ref="sl1"></Searchlist1>
      </van-tab>
      <van-tab title="进行中">
        <Searchlist2 ref="sl2"></Searchlist2>
      </van-tab>
      <van-tab title="已完成">
        <Searchlist3 ref="sl3"></Searchlist3>
      </van-tab>
      <van-tab title="已取消">
        <Searchlist4 ref="sl4"></Searchlist4>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import Searchlist1 from '../components/searchlist1'
import Searchlist2 from '../components/searchlist2'
import Searchlist3 from '../components/searchlist3'
import Searchlist4 from '../components/searchlist4'
export default {
  name: 'search',
  components: {
    Searchlist1, Searchlist2, Searchlist3, Searchlist4
  },
  data() {
    return {
      value: '',
      active: 0,
      message: '',
      searched: false,
      subdata: {
        value1: ''
      }
    }
  },
  computed: {
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      let active = parseInt(from.query.active)
      if (! isNaN(active)) {
        vm.setActive(active)
      }
    })
  },
  created() {
  },
  methods: {
    setActive(active) {
      this.active = active
    },
    onSearch(val) {
      this.$refs.sl1.setKey(val)
      this.$refs.sl2.setKey(val)
      this.$refs.sl3.setKey(val)
      this.$refs.sl4.setKey(val)
    }
  }
}
</script>
<style lang="less">
  .mysearch{
    .mysearchtabs{
      background-color:#F4F5FB;
      .van-tab{
        border-bottom:0.5px solid #F4F5FB;
      }
      .van-tabs__wrap{
        height:80px;
        .van-tabs__nav{
          height:69px;
          background-color:transparent;
        }
        .van-tab__text{
          font-weight: 400;
          font-size: 28px;
          color: #333333;
          line-height: 60px;
          height:69px;
        }
      }
    }
    .van-search{
      background-color:transparent;
      border-radius: 80px;
      overflow:hidden;
      height:64px;
      text-align:center;
      .van-field__control{
        text-align:center;
      }
      .van-icon-search{
        font-size:30px;
        margin-top:6px;
      }
      .van-search__content{
        background-color:#ffffff;
      }
    }
  }
</style>
<style lang="less" scoped>
  .mysearch{
    min-height:100vh;
    background-color: #f4f5fb;
    .sp1{
      height:30px;
    }
  }
</style>
